import { LoginController as controller } from './login.controller';
import template from './login.html';
import '../../common/ui/componentHeader/componentHeader';

export const loginComponent = {
  name: 'loginComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    returnTo: '<'
  }
};
